import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "bg-white dark:bg-gray-900 rounded-lg shadow-lg p-3 hover:shadow-xl transition-shadow duration-300" }
const _hoisted_2 = { class: "flex items-center space-x-2 mb-3" }
const _hoisted_3 = { class: "text-sm font-semibold text-gray-900 dark:text-white" }
const _hoisted_4 = { class: "px-2 py-0.5 bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300 text-xs rounded-full font-medium" }
const _hoisted_5 = { class: "space-y-1" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "absolute inset-0 bg-gradient-to-r from-blue-500/10 to-purple-500/10 animate-pulse"
}
const _hoisted_8 = { class: "relative flex items-center space-x-3 flex-1" }
const _hoisted_9 = { class: "flex-shrink-0" }
const _hoisted_10 = {
  key: 0,
  class: "w-4 h-4 transform group-hover:scale-110 transition-transform",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_11 = {
  key: 1,
  class: "w-4 h-4 transform group-hover:scale-110 transition-transform",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_12 = {
  key: 2,
  class: "w-4 h-4 transform group-hover:scale-110 transition-transform",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_13 = {
  key: 3,
  class: "w-4 h-4 transform group-hover:scale-110 transition-transform",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_14 = {
  key: 4,
  class: "w-4 h-4 transform group-hover:scale-110 transition-transform",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_15 = {
  key: 5,
  class: "w-4 h-4 transform group-hover:scale-110 transition-transform",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_16 = {
  key: 6,
  class: "w-4 h-4 transform group-hover:scale-110 transition-transform",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_17 = { class: "flex-1 min-w-0" }
const _hoisted_18 = { class: "text-xs font-medium text-gray-900 dark:text-white truncate" }
const _hoisted_19 = { class: "text-xs text-gray-500 dark:text-gray-400 flex items-center space-x-1" }
const _hoisted_20 = { class: "relative flex items-center space-x-2" }
const _hoisted_21 = {
  key: 0,
  class: "relative bg-gradient-to-r from-green-500 to-emerald-500 text-white text-xs rounded-full w-6 h-6 flex items-center justify-center font-bold shadow-lg animate-pulse hover:animate-none"
}
const _hoisted_22 = {
  key: 1,
  class: "w-2 h-2 bg-blue-500 rounded-full animate-pulse shadow-lg"
}

import { DeviceType, DEVICE_DISPLAY_NAMES } from '../../constants/device'

interface DeviceInfo {
  dimensions: { width: number; height: number }
  aspectRatio: string
  variationCount?: number
  hasMultipleVariations?: boolean
  totalVariations?: number
}

interface Props {
  availableDevices: DeviceType[]
  selectedDevice: DeviceType
  deviceInfo: Record<DeviceType, DeviceInfo>
  isWallpaperPack: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DeviceSelector',
  props: {
    availableDevices: {},
    selectedDevice: {},
    deviceInfo: {},
    isWallpaperPack: { type: Boolean }
  },
  emits: ["device-selected"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

const getDeviceDisplayName = (deviceType: DeviceType): string => {
  return DEVICE_DISPLAY_NAMES[deviceType as DeviceType] || deviceType
}

const selectDevice = (device: DeviceType) => {
  emit('device-selected', device)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "p-1.5 bg-gradient-to-r from-blue-500 to-purple-500 rounded-lg" }, [
        _createElementVNode("svg", {
          class: "w-4 h-4 text-white",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [
          _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 18h.01M8 21h8a1 1 0 001-1V4a1 1 0 00-1-1H8a1 1 0 00-1 1v16a1 1 0 001 1z"
          })
        ])
      ], -1)),
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.isWallpaperPack ? 'Devices' : 'Device'), 1),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.availableDevices.length), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableDevices, (device, index) => {
        return (_openBlock(), _createElementBlock("button", {
          key: device,
          onClick: ($event: any) => (selectDevice(device)),
          class: _normalizeClass([[
          'relative w-full p-2 rounded-md border transition-all duration-300 text-left flex items-center justify-between group overflow-hidden',
          _ctx.selectedDevice === device
            ? 'border-blue-500 bg-gradient-to-r from-blue-50 to-purple-50 dark:from-blue-900/20 dark:to-purple-900/20 shadow-md scale-105'
            : 'border-gray-200 dark:border-gray-700 hover:border-blue-300 dark:hover:border-blue-600 hover:bg-gray-50 dark:hover:bg-gray-800 hover:scale-102'
        ], "animate-fade-in-up"]),
          style: _normalizeStyle({ animationDelay: `${index * 100}ms` })
        }, [
          (_ctx.selectedDevice === device)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", {
                class: _normalizeClass([
              'p-2 rounded-lg transition-all duration-300',
              _ctx.selectedDevice === device 
                ? 'bg-gradient-to-r from-blue-500 to-purple-500 text-white shadow-lg' 
                : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 group-hover:bg-blue-100 dark:group-hover:bg-blue-900/30 group-hover:text-blue-600'
            ])
              }, [
                (device.includes('mobile') || device.includes('phone') || device.includes('iphone') || device.includes('android'))
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_10, _cache[2] || (_cache[2] = [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M12 18h.01M8 21h8a1 1 0 001-1V4a1 1 0 00-1-1H8a1 1 0 00-1 1v16a1 1 0 001 1z"
                      }, null, -1)
                    ])))
                  : (device.includes('tablet'))
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_11, _cache[3] || (_cache[3] = [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M12 18h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                        }, null, -1)
                      ])))
                    : (device.includes('desktop') || device.includes('ultrawide'))
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_12, _cache[4] || (_cache[4] = [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                          }, null, -1)
                        ])))
                      : (device.includes('laptop'))
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_13, _cache[5] || (_cache[5] = [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M3 17h18a1 1 0 001-1V4a1 1 0 00-1-1H3a1 1 0 00-1 1v12a1 1 0 001 1zm0 0v2a1 1 0 001 1h16a1 1 0 001-1v-2"
                            }, null, -1)
                          ])))
                        : (device.includes('tv'))
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_14, _cache[6] || (_cache[6] = [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M7 4V2a1 1 0 011-1h8a1 1 0 011 1v2h3a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h3z"
                              }, null, -1)
                            ])))
                          : (device.includes('watch'))
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_15, _cache[7] || (_cache[7] = [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                }, null, -1)
                              ])))
                            : (_openBlock(), _createElementBlock("svg", _hoisted_16, _cache[8] || (_cache[8] = [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z"
                                }, null, -1)
                              ])))
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, _toDisplayString(getDeviceDisplayName(device)), 1),
              _createElementVNode("div", _hoisted_19, [
                _cache[9] || (_cache[9] = _createElementVNode("svg", {
                  class: "w-3 h-3",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                  })
                ], -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.deviceInfo[device]?.dimensions.width) + "×" + _toDisplayString(_ctx.deviceInfo[device]?.dimensions.height), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            (_ctx.deviceInfo[device]?.variationCount > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createTextVNode(_toDisplayString(_ctx.deviceInfo[device].variationCount) + " ", 1),
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "absolute -inset-1 bg-green-400 rounded-full animate-ping opacity-30" }, null, -1))
                ]))
              : _createCommentVNode("", true),
            (_ctx.selectedDevice === device)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, _cache[11] || (_cache[11] = [
                  _createElementVNode("div", { class: "absolute inset-0 bg-blue-400 rounded-full animate-ping opacity-50" }, null, -1)
                ])))
              : _createCommentVNode("", true)
          ]),
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700 ease-out" }, null, -1))
        ], 14, _hoisted_6))
      }), 128))
    ])
  ]))
}
}

})